import React, { Fragment, useState, useContext } from 'react'
import { Button, Dialog, DialogContent, DialogActions } from '@mui/material'

import withStyles from '@mui/styles/withStyles'

import { AuthContext } from 'contexts/auth'
import SwitchOrgranisationInput from './input'
import { setLocalStorageOrganisationIds } from './helpers'

const styles = (theme: any) => ({
  paperFullWidth: {
    overflowY: 'visible'
  },

  dialogContentRoot: {
    overflowY: 'visible'
  },
})

type Props = {
  onClose: () => void;
  submitting: boolean;
  classes: any;
};

const SwitchOrganisation = ({
  onClose,
  submitting = false,
  classes,
}: Props) => {
  const [organisationIds, setOrganistationIds] = useState()
// @ts-expect-error - TS2339 - Property 'fetchSessionInfo' does not exist on type 'unknown'.
  const { fetchSessionInfo } = useContext(AuthContext)

  const handleSubmit = () => {
    setLocalStorageOrganisationIds(organisationIds)
    fetchSessionInfo()
    onClose()
  }

  const onDialogClose = (event: any, reason: string) => {
    if(reason === 'backdropClick' || reason === 'escapeKeyDown'){
      onClose()
    }
  }

  return (
    <Dialog
      open
      fullWidth
      maxWidth='lg'
      onClose={onDialogClose}
      classes={{ paperFullWidth: classes.paperFullWidth }}
    >
      <Fragment>
        <DialogContent classes={{ root: classes.dialogContentRoot }}>
{ /* @ts-expect-error - TS2322 - Type 'Dispatch<SetStateAction<undefined>>' is not assignable to type '(values: string[]) => void'. */}
          <SwitchOrgranisationInput setOrganistationIds={setOrganistationIds} />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={onClose}
            disabled={submitting}
            variant='outlined'
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            disabled={submitting}
            type='submit'
            onClick={handleSubmit}
          >
            Save
          </Button>
        </DialogActions>
      </Fragment>
    </Dialog>
  )
}

// @ts-expect-error - TS2345 - Argument of type '(theme: any) => { paperFullWidth: { overflowY: string; }; dialogContentRoot: { overflowY: string; }; }' is not assignable to parameter of type 'Styles<any, any, string>'.
export default withStyles(styles)(SwitchOrganisation)
